import { SESSION_STORAGE_KEY } from '../constant/Constant';
import NullCheckUtil from './NullCheckUtil';
import SessionStorage from './SessionStorageUtil';

class CodeUtil {
    static getCodes(cdGrpId) {
        var codes = SessionStorage.get(SESSION_STORAGE_KEY.CODE).filter((group) => group.codeGroup.cdGrpId === cdGrpId);
        if (Array.isArray(codes) && codes.length > 0) {
            return codes[0].codeDetails;
        } else {
            console.error(cdGrpId + '의 공통코드가 존재하지 않습니다.');
            return [
                {
                    cdGrpId,
                    cdGrpNm: '',
                    cd: '',
                    cdNm: '',
                },
            ];
        }
    }
    static getCodeName(cdGrpId, cd) {
        var code = CodeUtil.getCodes(cdGrpId).find((code) => code.cd == cd);
        if (NullCheckUtil.isNotNull(code)) {
            return code.cdNm;
        } else {
            console.error(cdGrpId + '의 ' + cd + ' 공통코드가 존재하지 않습니다.');
            return '';
        }
    }
    static getCodeByPropDesc(cdGrpId, cdPropDesc) {
        return SessionStorage.get(SESSION_STORAGE_KEY.CODE)
            .filter((group) => group.codeGroup.cdGrpId === cdGrpId)[0]
            .codeDetails.find((code) => code.cdPropDesc == cdPropDesc);
    }
    static getFirstCode(cdGrpId) {
        return CodeUtil.getCodes(cdGrpId)[0].cd;
    }
    static getFirstCodeName(cdGrpId) {
        return CodeUtil.getCodes(cdGrpId)[0].cdNm;
    }
    static getFirstCodePropDesc(cdGrpId) {
        return CodeUtil.getCodes(cdGrpId)[0].cdPropDesc;
    }
    static getPropDescByCode(cdGrpId, cd) {
        return SessionStorage.get(SESSION_STORAGE_KEY.CODE)
            .filter((group) => group.codeGroup.cdGrpId === cdGrpId)[0]
            .codeDetails.find((code) => code.cd == cd).cdPropDesc;
    }
}

export default CodeUtil;
